
import { MessageBox } from "element-ui";
/**
 *
 * @param {*} param
 * @param {*} noTime  // 是否不需要倒计时  true 不需要  false 需要
 * @returns
 */
export const confirmMessage = async({title='提示',confirmButtonText='确认',time=5,messagesHtml='',type=''},noTime)=>{
  let countDown = time; // 倒计时
  let timer=null; // 定时器
  // 因弹框出来后 dom 没有销毁
  let btnClass = document.getElementsByClassName('customConfirmButtonClass')[0];
  if(btnClass){ // 当已存在 弹款时
    btnClass.innerHTML = noTime?confirmButtonText:`${confirmButtonText}(${countDown})`;
    if(noTime){
      btnClass.classList.remove('is-disabled')
    }else{
      btnClass.classList.add('is-disabled');
    }
  }
  if(!noTime){
    timer = setInterval(()=>{
      countDown--
      if(!btnClass) btnClass= document.getElementsByClassName('customConfirmButtonClass')[0];
      btnClass.classList.add('is-disabled');
      if(countDown=== 0){
        clearInterval(timer);
        countDown =time
        btnClass.innerHTML = confirmButtonText;
        btnClass.classList.remove('is-disabled');
      }else{
        btnClass.innerHTML = `${confirmButtonText}(${countDown})`;
      }
    },1000)
  }

  const clearTime = ()=>{
    clearInterval(timer);
    timer=null;
    countDown=0
  }
  let flag =false;
  try {
    await MessageBox.confirm(messagesHtml, title, {
      confirmButtonText: noTime?confirmButtonText:`${confirmButtonText}(${countDown})`,
      cancelButtonText: '取消',
      confirmButtonClass: `customConfirmButtonClass ${noTime?'':'is-disabled'}`,
      customClass: 'customConfirmClass',
      type:type,
      dangerouslyUseHTMLString: true,
      beforeClose:(action, instance, done)=>{
        if(!(action=='confirm'&&btnClass?.className?.indexOf('is-disabled')>=0)){
          clearTime()
          done()
        }
      }
    })
    flag=true
  } catch (error) {
    return
  }finally{
    return new Promise(async(resolve,reject)=>{
      if(flag) resolve()
      if(!flag) reject()
    })
  }
}
